import { forwardRef, JSX } from 'react';
import { Box, BoxProps } from '../Box';
import { bgBase } from '../../styles/background';
import { mergeClassAttributes } from '../../helpers/classes';

const classes = `${bgBase} p-3 rounded-lg border-slate-300 dark:border-slate-700 border-1`;

export const Card = forwardRef<HTMLDivElement, BoxProps>(
  (props, ref): JSX.Element => (
    <Box
      ref={ref as any}
      {...props}
      className={mergeClassAttributes(props, classes)}
    />
  ),
);

Card.displayName = 'Card';

export default Card;
